"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitNamespaces = splitNamespaces;
exports.mergeRows = mergeRows;
exports.validateNamespaceData = validateNamespaceData;
// packages/shared/src/content/messages.ts
const registry_1 = require("./registry");
function splitNamespaces(full) {
    return Object.entries(full).map(([page, data]) => ({ page, data }));
}
function mergeRows(rows) {
    const out = {};
    for (const row of rows) {
        out[row.page] = row.data;
    }
    return out;
}
function validateNamespaceData(page, data) {
    const ns = registry_1.registry[page];
    if (!ns)
        throw new Error(`Bilinmeyen namespace: ${page}`);
    const input = (data && typeof data === "object" ? data : {});
    const out = {};
    // Yalnız registry'deki anahtarlar; eksikler boş string. Bilinmeyenler atılır.
    for (const key of Object.keys(ns.fields)) {
        const value = input[key];
        out[key] = typeof value === "string" ? value : "";
    }
    return out;
}
//# sourceMappingURL=messages.js.map